import React, { useState } from 'react';
import { Calendar, Clock, MapPin, Users, Send, Plus, X } from 'lucide-react';
import styles from './test_form.module.css';
import { meetAndMail } from '../utils/meet_mail';

const MeetingCreatorForm = () => {
  const [formData, setFormData] = useState({
    summary: '',
    description: '',
    startDateTime: '',
    endDateTime: '',
    attendees: [],
    location: '',
    sendNotifications: true
  });

  const [attendeeInput, setAttendeeInput] = useState('');

  // Common time zones for dropdown
  const timeZones = [
    'Asia/Kolkata',
    'UTC',
    'America/New_York',
    'America/Los_Angeles',
    'Europe/London',
    'Asia/Tokyo',
    'Australia/Sydney'
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const addAttendee = (e) => {
    e.preventDefault();
    if (attendeeInput.trim() && !formData.attendees.includes(attendeeInput.trim().toLowerCase())) {
      setFormData(prev => ({
        ...prev,
        attendees: [...prev.attendees, attendeeInput.trim().toLowerCase()]
      }));
      setAttendeeInput('');
    }
  };

  const removeAttendee = (emailToRemove) => {
    setFormData(prev => ({
      ...prev,
      attendees: prev.attendees.filter(email => email !== emailToRemove)
    }));
  };

  const generateEndTime = (startDateTime) => {
    if (startDateTime) {
      const start = new Date(startDateTime);
      const end = new Date(start.getTime() + 30 * 60000); // Add 30 minutes
      return end.toISOString().slice(0, 16);
    }
    return '';
  };

//   const handleStartDateTimeChange = (e) => {
//     const startDateTime = e.target.value;
//     setFormData(prev => ({
//       ...prev,
//       startDateTime,
//       endDateTime: generateEndTime(startDateTime)
//     }));
//   };


  const handleStartDateTimeChange = (e) => {
  const inputValue = e.target.value.trim();

  // Validate: basic check for time format
  if (!inputValue || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(inputValue)) {
    console.warn("Invalid date-time format");
    return;
  }

  // If the input is local time (Asia/Kolkata), preserve it as-is
  const startDateTime = `${inputValue}:00`; // Add seconds if needed

  // Auto-generate end time based on start
  const endDateTime = generateEndTime(startDateTime);


  // Update state
  setFormData(prev => ({
    ...prev,
    startDateTime,

    endDateTime
  }));
};



  const handleSubmit = async (e) => {
    e.preventDefault();
    // Form submission logic would go here
    
    try {
        const submissionData = {
  ...formData,
  startDateTime: new Date(formData.startDateTime).toISOString(),
  endDateTime: new Date(formData.endDateTime).toISOString(),
        }

    console.log('Form Data:', submissionData);
    const response =  await meetAndMail(submissionData);
        console.log("Meeting created successfully:", response);

    }catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to create meeting. Please try again.");
      return;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <Calendar className={styles.titleIcon} size={28} />
          Create Meeting
        </h2>
        <p className={styles.subtitle}>Schedule a new meeting with Google Meet</p>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        {/* Meeting Title */}
        <div className={styles.field}>
          <label className={styles.label}>
            Meeting Title *
          </label>
          <input
            type="text"
            name="summary"
            value={formData.summary}
            onChange={handleInputChange}
            placeholder="e.g., Team Standup"
            className={styles.input}
            required
          />
        </div>

        {/* Description */}
        <div className={styles.field}>
          <label className={styles.label}>
            Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            placeholder="Meeting agenda or description"
            rows="3"
            className={styles.textarea}
          />
        </div>

        {/* Date and Time */}
        <div className={styles.dateTimeGrid}>
          <div className={styles.field}>
            <label className={styles.label}>
              <Clock className={styles.labelIcon} size={16} />
              Start Date & Time *
            </label>
            <input
              type="datetime-local"
              name="startDateTime"
              value={formData.startDateTime}
              onChange={handleStartDateTimeChange}
              className={styles.input}
              required
            />
          </div>
          
          <div className={styles.field}>
            <label className={styles.label}>
              <Clock className={styles.labelIcon} size={16} />
              End Date & Time *
            </label>
            <input
              type="datetime-local"
              name="endDateTime"
              value={formData.endDateTime}
              onChange={handleInputChange}
              className={styles.input}
              required
            />
          </div>
        </div>

        {/* Timezone */}
        <div className={styles.field}>
          <label className={styles.label}>
            Time Zone
          </label>
          <select
            name="timeZone"
            value={formData.timeZone}
            onChange={handleInputChange}
            className={styles.select}
          >
            {timeZones.map(tz => (
              <option key={tz} value={tz}>{tz}</option>
            ))}
          </select>
        </div>

        {/* Location */}
        <div className={styles.field}>
          <label className={styles.label}>
            <MapPin className={styles.labelIcon} size={16} />
            Location
          </label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleInputChange}
            placeholder="e.g., Conference Room A or Address"
            className={styles.input}
          />
        </div>

        {/* Attendees */}
        <div className={styles.field}>
          <label className={styles.label}>
            <Users className={styles.labelIcon} size={16} />
            Attendees
          </label>
          
          <div className={styles.attendeeInput}>
            <input
              type="email"
              value={attendeeInput}
              onChange={(e) => setAttendeeInput(e.target.value)}
              placeholder="Enter email address"
              className={styles.inputFlex}
            />
            <button
              type="button"
              onClick={addAttendee}
              className={styles.addButton}
            >
              <Plus size={16} />
            </button>
          </div>

          {/* Attendee List */}
          {formData.attendees.length > 0 && (
            <div className={styles.attendeeList}>
              {formData.attendees.map((email, index) => (
                <div key={index} className={styles.attendeeItem}>
                  <span className={styles.attendeeEmail}>{email}</span>
                  <button
                    type="button"
                    onClick={() => removeAttendee(email)}
                    className={styles.removeButton}
                  >
                    <X size={16} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Send Notifications */}
        <div className={styles.checkboxField}>
          <input
            type="checkbox"
            name="sendNotifications"
            id="sendNotifications"
            checked={formData.sendNotifications}
            onChange={handleInputChange}
            className={styles.checkbox}
          />
          <label htmlFor="sendNotifications" className={styles.checkboxLabel}>
            Send email notifications to attendees
          </label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className={styles.submitButton}
        >
          <Send size={20} />
          Create Meeting
        </button>
      </form>
    </div>
  );
  
};

export default MeetingCreatorForm;